/**
 * AI Chat Drawer Redux Slice
 *
 * Manages the visibility state of the AI chat drawer globally.
 * This allows the drawer to be opened/closed from anywhere in the app,
 * including from tool side effects during agent navigation.
 */

import { createSlice } from '@reduxjs/toolkit';

type AIChatDrawerState = {
  isOpen: boolean;
};

const initialState: AIChatDrawerState = {
  isOpen: false,
};

const aiChatDrawerSlice = createSlice({
  name: 'aiChatDrawer',
  initialState,
  reducers: {
    openDrawer: state => {
      state.isOpen = true;
    },
    closeDrawer: state => {
      state.isOpen = false;
    },
    toggleDrawer: state => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openDrawer, closeDrawer, toggleDrawer } =
  aiChatDrawerSlice.actions;

export default aiChatDrawerSlice;
